// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__7aLcM"};